import React, { createContext } from "react";

export const LoginSuccessContext = createContext();
export const LoginSuccessContextProvider = ({ children }) => {
  const providerValue = {};

  return (
    <LoginSuccessContext.Provider value={providerValue}>
      {children}
    </LoginSuccessContext.Provider>
  );
};
